module.exports = __webpack_public_path__ + "media/images/soar/progress-3e0af2c93cbf68474f31d0479417046a.jpg";